"use client";

import './index.css';
import { __rest } from '../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { validateSurface } from '../../globals.js';
import styles from './text-link.module.scss.js';

/**
 * @component TextLink
 * @package Buttons
 * @document ../_docs/code/TextLink.editor.tsx
 * @document ../_docs/code/TextLink.snippet.tsx
 * @document ../_docs/code/TextLink.import.tsx
 */
const TextLink = forwardRef((_a, ref) => {
    var { href, surface: surfaceProp = 'lightPrimary', role, children, size = 'large', kind = 'standalone', disabled, tabIndex, wrapText = false, onKeyDown, onClick, ariaLabel, 'aria-label': ariaLabelValue, 'data-testid': testId = 'text-link' } = _a, rest = __rest(_a, ["href", "surface", "role", "children", "size", "kind", "disabled", "tabIndex", "wrapText", "onKeyDown", "onClick", "ariaLabel", 'aria-label', 'data-testid']);
    // Validate surface prop
    const surface = validateSurface(surfaceProp);
    const textLinkStyles = [styles.textLink];
    textLinkStyles.push(styles[surface.toLowerCase()]);
    textLinkStyles.push(styles[kind]);
    if (size === 'small')
        textLinkStyles.push(styles.small);
    if (wrapText)
        textLinkStyles.push(styles.wrapText);
    if (disabled)
        textLinkStyles.push(styles.disabled);
    const _calculateRole = () => {
        switch (true) {
            case !!role:
                return role;
            case !!href:
                return 'link';
            default:
                return 'button';
        }
    };
    const _calculateAriaLabel = () => {
        switch (true) {
            case !!ariaLabel:
                return ariaLabel;
            case !!ariaLabelValue:
                return ariaLabelValue;
            case !!children && typeof children === 'string':
                return children;
            default:
                return 'Text Link';
        }
    };
    const _onKeyDown = (e) => {
        if (onKeyDown)
            onKeyDown(e);
        if ((e.key === 'Enter' || e.key === ' ') && onClick) {
            e.target.click();
        }
    };
    const _onClick = (e) => {
        // reassign the target due to the hit area propogation
        const newEvent = e;
        newEvent.target = e.currentTarget;
        /* istanbul ignore else */
        if (onClick)
            return onClick(newEvent);
    };
    return (jsxs("a", Object.assign({}, rest, { className: textLinkStyles.join(' '), href: href, role: _calculateRole(), "aria-label": _calculateAriaLabel(), "aria-disabled": disabled, ref: ref, onKeyDown: _onKeyDown, onClick: _onClick, "data-testid": testId, tabIndex: disabled ? -1 : tabIndex || 0, children: [jsx("span", { className: "VDS__MON-textlink-hitarea" }), jsx("span", { className: "VDS__MON-textlink-childcontainer", children: children })] })));
});

export { TextLink, TextLink as default };
